import { render } from "./CustomerItem.vue?vue&type=template&id=efe3553a"
import script from "./CustomerItem.vue?vue&type=script&lang=js"
export * from "./CustomerItem.vue?vue&type=script&lang=js"

import "./CustomerItem.vue?vue&type=style&index=0&id=efe3553a&lang=css"
script.render = render

export default script